export enum InviteeStatus {
  Pending = 'PENDING',
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
}

export enum ReminderTime {
  FiveMinutes = 300000,
  TenMinutes = 600000,
  HalfHour = 1800000,
  OneHour = 3600000,
  TwoHours = 7200000,
  OneDay = 86400000,
}
